export const crystalBaseUrl = () => {
  return "https://crystal.in.ua/api/";
};

export const defaultLang = "uk";

export const shop = {
  SORT_OPTIONS: {
    PRICE_ASC: "price_asc",
    PRICE_DESC: "price_desc",
  },
};
